/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useUpdateSelectedPayers
 */
import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import { getOnboardingHeaders } from '../useRegisteredPayers';
import AppEvents from '@veritable/common/utils/appEvents';
import { invalidateMetadata } from 'app-constants/queryKeys';

/**
 * Mutate for useUpdateSelectedPayers
 */
const useUpdateSelectedPayers = (onBoarding?: boolean): UseMutationResult<unknown, IAxiosError, Payers.IPayerUpdateModel[], unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			const { data } = await api.PayersApi.patchPayer({ payerUpdateModel: model }, getOnboardingHeaders(onBoarding));
			return data;
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateSelectedPayers;
